<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <!-- <img :src="icon" class="icon" /> -->
      <div class="info">
        <!-- <p>
          {{ this.$store.getters.REQUESTED_VEHICLE_INFO.takeUser.firstName }}
          {{ this.$store.getters.REQUESTED_VEHICLE_INFO.takeUser.lastName }}
        </p>
        <br />
        <p>Your Car is Ready!</p>-->
        <p>{{ this.$store.getters.TRANSLATIONS["would_you_like_to_tip"] }}</p>
      </div>
      <div class="tip">
        <button class="button amount">{{ tip }}</button>
        <div class="controls">
          <img v-on:click="minus()" :src="minusIcon" />
          <img v-on:click="plus()" :src="plusIcon" />
        </div>
        <!-- <button class="button minus">
          <img v-on:click="minus()" :src="minusIcon" />
        </button>
        <button class="button plus">
          <img v-on:click="plus()" :src="plusIcon" />
        </button>-->
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="submitTip()" class="button">
        {{ this.$store.getters.TRANSLATIONS["submit_tip"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  computed: {
    tip: {
      get: function () {
        return (
          "$ " +
          this.tipValue
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      }
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      tipValue: 2,
      icon: require("@/assets/valet_user_default_icon.png"),
      plusIcon: require("@/assets/icons8-plus-48.png"),
      minusIcon: require("@/assets/icons8-minus-48.png"),
      back: () => {
        this.$router.go(-1);
      },
      plus: () => {
        this.tipValue = parseFloat((this.tipValue + 1).toFixed(2));
      },
      minus: () => {
        const newValue = parseFloat((this.tipValue - 1).toFixed(2));
        if (newValue >= 0) this.tipValue = newValue;
      },
      submitTip: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/2E5E67F509534E64996C6A806C8FD375`,
            {
              vehicleId: this.$store.getters.REQUESTED_VEHICLE.id,
              tipCharge: this.tipValue
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Add tip charge response:");
            console.log(response);
            if (response && response.status === 200) {
              this.$store.dispatch("SAVE_LAST_PARKING_TIP", this.tipValue);
              this.$router.push("/parkingReceipt");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/requestInProgress");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.info p {
  color: white;
  margin: 0 17vw;
}
.tip {
  margin: 5vh 17vw 0;
}
.tip button {
  width: 100%;
}
.amount {
  background-color: white;
  color: #fbae31;
  width: 80% !important;
  float: left;
}
.controls {
  position: absolute;
  border-radius: 100px;
  margin-left: 42vw;
  margin-top: 3.5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 30vw;
  height: 5.5vh;
  background-color: #dedede;
}
.controls img {
  -webkit-filter: opacity(0.5) drop-shadow(0 0 0 blue);
  filter: opacity(0.5) drop-shadow(0 0 0 blue);
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/CarReady.vue